import { render, staticRenderFns } from "./DonorList.vue?vue&type=template&id=266e6be0&"
import script from "./DonorList.vue?vue&type=script&lang=js&"
export * from "./DonorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports